import collection from "@/store/collection.store-partial";
import tutorialStepModule from "@/store/tutorial/steps/single.store";
import { LOCAL } from "@/store/mutations";

const { SET_TUTORIAL_STEP_INDEX } = LOCAL;

export default {
	namespaced: true,
	modules: {
		collection,
	},
	state: {
		index: 0,
	},
	getters: {
		active: (state, getters) => getters.ordered[state.index],
		nextIndex: (state) => state.index + 1,
		nextStep: (state, getters) => getters.ordered[getters.nextIndex],
		hasNextStep: (state, getters) => typeof getters.nextStep === "object",
	},
	actions: {
		configureApp: {
			root: true,
			handler({ dispatch }, configData) {
				dispatch("populate", {
					items: configData.tutorial.steps,
					path: ["tutorial", "steps"],
					module: tutorialStepModule,
				});
			},
		},
		activate({ commit }, step) {
			commit(SET_TUTORIAL_STEP_INDEX, step);
		},
	},
	mutations: {
		[SET_TUTORIAL_STEP_INDEX](state, activate) {
			state.index = activate.index;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/tutorial/steps/list.store.js